import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "../css/nav.css";
import logo from "../images/logo.png";
import { Link } from "react-router-dom";

const Nav = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLinkClick = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    if (isHomePage) {
      window.addEventListener("scroll", handleScroll);
    } else {
      setIsScrolled(false);
    }

    return () => window.removeEventListener("scroll", handleScroll);
  }, [isHomePage]);

  return (
    <nav className={`${isHomePage && !isScrolled ? "transparent" : "solid"} ${isScrolled ? "scrolled" : ""}`}>
      <img src={logo} alt="Logo" className="logo" />
      <ul className={`nav-links ${isMenuOpen ? "open" : ""}`}>
        <li>
          <Link to="/" className={location.pathname === "/" ? "active" : ""} onClick={handleLinkClick}>
            Home
          </Link>
        </li>
        <li>
          <Link to="/about" className={location.pathname === "/about" ? "active" : ""} onClick={handleLinkClick}>
            About
          </Link>
        </li>
        
        <li>
          <Link to="/plantrip" className={location.pathname === "/plantrip" ? "active" : ""} onClick={handleLinkClick}>
            Plan Your Trip
          </Link>
        </li>
        <li>
          <Link to="/contact" className={location.pathname === "/contact" ? "active" : ""} onClick={handleLinkClick}>
            Contact
          </Link>
        </li>
        <li>
          <Link to="/report"  onClick={handleLinkClick}>
            <button>Download 2023 Impact Report</button>
          </Link>
        </li>
      </ul>
      <div className={`hamburger ${isMenuOpen ? "open" : ""}`} onClick={toggleMenu}>
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </div>
    </nav>
  );
};

export default Nav;